import { createContext, useContext } from "react";

type DialogMode = "portal" | "inline";
const DialogModeContext = createContext<DialogMode>("portal");

export function useDialogMode(): DialogMode {
  return useContext(DialogModeContext);
}

export { DialogModeContext };
